import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryChangedTypes } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { mapDropdownOptions } from '@utils/formatter';

import { TDumpConsistencyIdAndPath } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_CHANGED_TYPES } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryChangedTypes {
	consistencyCheckChangedTypes: TSelectOption<string>[];
	isLoadingConsistencyCheckChangedTypes: boolean;
}

const useConsistencyCheckHistoryChangedTypes = (
	params: Partial<TDumpConsistencyIdAndPath>,
): IUseConsistencyCheckHistoryChangedTypes => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_CHANGED_TYPES, params],
		queryFn: extractQueryParams(getConsistencyCheckHistoryChangedTypes),
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		enabled: [!!params.dumpConsistencyId, !!params.dataModelPathId],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckChangedTypes: data || [],
		isLoadingConsistencyCheckChangedTypes: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryChangedTypes;
